import Config from "../config";
import { ContactCustomAttribute, mapToMediaModel } from "./conversations";
import { CustomAttributeDefinitionModel, mapToCustomAttributeDefinition } from "./custom-attribute.model";
import { MediaModel } from "./templates.models";

export const enum WebFormStatus {
    Published = 0,
    Draft = 1,
    Paused = 2,
    Deleted = 3,
    Start = 4
}

export class WebFormModel {
    constructor() { }

    Id: string;
    Title: string;
    Description: string;
    ButtonLabel: string;
    Logo: MediaModel;
    PrivacyPolicyUrl: string;
    TermsConditionUrl: string;
    SelectedGroups: { GroupName: string, GroupId: string, PhoneNumber: string }[]
    CustomContactAttributes: CustomAttributeDefinitionModel[]
    Status: WebFormStatus;
    PhoneNumbers: string[];
    CreatedDateTime: string;
    CreatedById: string;
    UpdatedDateTime: string;
    UpdatedById: string;
    IsDeleted: boolean;
    SubmissionsCount: number;
    FieldIdsOrder: string[];
}

export class SubmitedContactModel {
    constructor() { }

    Name: string;
    PhoneNumber: string;
    FormId: string;
    Email: string;
    Groups: string[];
    CreatedDateTime: string;
    CustomAttributes: ContactCustomAttribute[] // add type inside customattribute
}

export class WebFormHistoryModel {
    constructor() { }

    SubmissionsCount: number;
    Views: number;
    SubmissionContacts: SubmitedContactModel[];
}

export const mapToSubmitedContactModel = (x: any): SubmitedContactModel => {
    return {
        Name: x.name,
        PhoneNumber: x.phoneNumber,
        FormId: x.formId,
        Email: x.email,
        Groups: x?.groupNames ?? [],
        CreatedDateTime: x?.createdDateTime,
        CustomAttributes: x.customAttributes ?? []
    }
}

export const mapToWebFormHistoryModel = (x: any): WebFormHistoryModel => {
    return {
        SubmissionsCount: x.subissionsCount ?? 0,
        Views: x.views ?? 0,
        SubmissionContacts: x?.submitedContacts?.map(mapToSubmitedContactModel),
    }
}

export const mapToWebFormModel = (x: any, endUserSide: boolean = false): WebFormModel => {
    return {
        Id: x.id,
        Title: x.title,
        Description: x.description,
        ButtonLabel: x.buttonLabel,
        Logo: !!x.logo ? !endUserSide ? mapToMediaModel(x.logo) : {
            ID: x.id,
            Name: x.name,
            ContentType: x.contentType,
            Url: `${Config.API_URL}/api/File/${x?.logo?.id}/view/${x?.logo?.name}`
        } : null,
        PrivacyPolicyUrl: x.privacyPolicyUrl,
        TermsConditionUrl: x.termsConditionUrl,
        SelectedGroups: x.selectedGroups.map(x => ({ GroupName: x.groupName, GroupId: x.groupId, PhoneNumber: x.phoneNumber })),
        CustomContactAttributes: x.customContactAttributes.map(mapToCustomAttributeDefinition),
        Status: x.status,
        PhoneNumbers: x.phoneNumbers,
        CreatedDateTime: x.createdDateTime,
        CreatedById: x.createdById,
        UpdatedDateTime: x.updatedDateTime ?? x.createdDateTime,
        UpdatedById: x.updatedById,
        IsDeleted: x.isDeleted,
        SubmissionsCount: x.submissionsCount,
        FieldIdsOrder: x?.fieldIdsOrder ?? [],
    }
}